<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    clearable
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import constants from "../../../helpers/constants";

export default {
  name: "ExpressionFunctionPicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: [
        constants.FUNC_addDay,
        constants.FUNC_addMonth,
        constants.FUNC_addYear,
        constants.FUNC_addHour,
        constants.FUNC_addMinute,
        constants.FUNC_addSecond,
        constants.FUNC_getDay,
        constants.FUNC_getMonth,
        constants.FUNC_getYear,
        constants.FUNC_getHour,
        constants.FUNC_getMinute,
        constants.FUNC_getSecond,
        constants.FUNC_getDate,
        constants.FUNC_getPrefix,
        constants.FUNC_getSuffix,
        constants.FUNC_getChar,
        constants.FUNC_not,
        constants.FUNC_isNull,
        constants.FUNC_isNotNull,
        constants.FUNC_isLate,
        constants.FUNC_isNotLate,
      ],
    };
  },

  computed: {
    rules() {
      return this.isRequired
        ? ui.requiredRules(this.$store.getters.required)
        : [];
    },
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>